import React, { useState, useEffect } from "react";
import { Divider, Item, Icon, List } from "semantic-ui-react";
import "./index.scss";

import { varieties, varietyFormatted, getMissingDocs } from "./helpers";
import DocList from "./DocList";
import UploadForm from "./UploadForm";

export default function DealerCoi({ dealerId, docs, fetchData }) {
  const firstMissingDoc = docs.find(
    (f) => f.variety === undefined && !f.filename
  );
  const acceptedDocs = docs
    .filter((f) => f.accepted && !f.archived)
    .sort((a, b) => a.variety - b.variety);
  const expiredDocs = docs.filter((f) => f.expired);
  const pendingDocs = docs.filter(
    (f) => !f.expired && !f.accepted && f.variety !== undefined
  );
  const missingDocs = getMissingDocs([...pendingDocs, ...acceptedDocs]).map(
    (m) => ({
      text: varietyFormatted[m],
      value: m,
    })
  );

  return (
    <div>
      <Item.Group>
        <Item>
          <Item.Content>
            <Item.Header content="Certificate of Insurance" />
            <Item.Meta content="The Certificate of Insurance document" />
            <div style={{ margin: "1em 0" }}>
              {missingDocs.length > 0 && (
                <React.Fragment>
                  <h4>
                    Missing <Icon name="question circle" color="red" />
                  </h4>
                  {missingDocs.length === 4 && (
                    <p>Upload one of the documents below to get started.</p>
                  )}
                  <List divided>
                    {missingDocs.map((m, i) => (
                      <List.Item key={i}>
                        <List.Content floated="right">
                          <UploadForm
                            key={i}
                            dealerId={dealerId}
                            onSuccess={fetchData}
                            documentId={
                              firstMissingDoc ? firstMissingDoc.id : null
                            }
                            variety={m.value}
                          />
                        </List.Content>
                        <List.Content>
                          <b>{m.text}</b>
                        </List.Content>
                      </List.Item>
                    ))}
                  </List>
                </React.Fragment>
              )}
            </div>
            <DocList
              docs={acceptedDocs}
              title="Current"
              accepted
              fetchData={fetchData}
              dealerId={dealerId}
              defaultOpen
            />
            <DocList
              docs={pendingDocs}
              title="Pending"
              pending
              fetchData={fetchData}
              dealerId={dealerId}
              defaultOpen
            />
            {/* <DocList
              docs={expiredDocs}
              title="Expired"
              expired
              fetchData={fetchData}
              dealerId={dealerId}
            /> */}
          </Item.Content>
        </Item>
      </Item.Group>
      <Divider />
    </div>
  );
}

DealerCoi.defaultProps = {
  docs: [],
};
